module.exports = __webpack_public_path__ + "img/alphabet-dosis.544dbe63.jpg";